import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Businessunit } from './businessunit';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BusinessunitService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Businessunit[]> {
    return this.httpClient.get<Businessunit[]>(this.baseUrl + 'api/BusinessunitApi')
  }
  Post(businessunit: Businessunit): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/BusinessunitApi/add', businessunit, { headers: header, observe: 'response' })
  }
  Delete(businessunit: Businessunit) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/BusinessunitApi/activeordeactive', businessunit, { headers: header, observe: 'response' })
  }
  Put(businessunit: Businessunit): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/BusinessunitApi/Update', businessunit, { headers: header, observe: 'response' })
  }
  GetActives(): Observable<Businessunit[]> {
    return this.httpClient.get<Businessunit[]>(this.baseUrl + 'api/BusinessunitApi/GetActive')

  }

}
